







import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Form extends Vue {
  prevent(e: any) {
    e.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newprogram/components/form/Form.vue